var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const withSubComponent = /* @__PURE__ */ __name((component, subComponents) => Object.assign(component, subComponents), "withSubComponent");

export { withSubComponent };
//# sourceMappingURL=with-sub-components.js.map
